<template>
  <div v-if="movie">
    <label for="movie_name">Name</label>
    <input type="text" class="form-control" id="movie_name" v-model="movie.name">

    <label for="audio_format">Audio Format</label>
    <input type="text" class="form-control" id="audio_format" v-model="movie.audio_format">

    <label for="audio_quality">Audio Quality</label>
    <input type="text" class="form-control" id="audio_quality" v-model="movie.audio_quality">

    <label for="audio_type">Audio Type</label>
    <input type="text" class="form-control" id="audio_type" v-model="movie.audio_type">

    <label for="chapters">Chapters</label>
    <input type="text" class="form-control" id="chapters" v-model="movie.chapters">

    <label for="container">Container</label>
    <input type="text" class="form-control" id="container" v-model="movie.container">

    <label for="duration">Duration</label>
    <input type="text" class="form-control" id="duration" v-model="movie.duration">

    <label for="metadata">Metadata</label>
    <input type="text" class="form-control" id="metadata" v-model="movie.metadata">

    <label for="notes">Notes</label>
    <input type="text" class="form-control" id="notes" v-model="movie.notes">

    <label for="release_date">Release Date</label>
    <input type="text" class="form-control" id="release_date" v-model="movie.release_date">

    <label for="size">Size</label>
    <input type="text" class="form-control" id="size" v-model="movie.size">

    <label for="subtitles">Subtitles</label>
    <input type="text" class="form-control" id="subtitles" v-model="movie.subtitles">

    <label for="titles">Titles</label>
    <input type="text" class="form-control" id="titles" v-model="movie.titles">

    <label for="video_format">Video Format</label>
    <input type="text" class="form-control" id="video_format" v-model="movie.video_format">

    <label for="video_quality">Video Quality</label>
    <input type="text" class="form-control" id="video_quality" v-model="movie.video_quality">

    <button v-on:click="updateMovie" type="button" class="btn btn-success">Update Movie</button>
  </div>

  <div v-else>
    There's actually nothing here.
  </div>
</template>

<script>

import { MovieService } from '@/common/services/movie.service';

export default {
  name: 'MovieEdit',
  components: {

  },
  props: [
    'id',
  ],
  data() {
    return {
      movie: null,
      errors: [],
    };
  },
  created() {
    this.getMovie(this.id);
  },
  methods: {
    getMovie(params) {
      MovieService.get(params).then((response) => {
        this.movie = response.data;
      });
    },
    updateMovie() {
      MovieService.update(this.id, this.movie)
        .then(() => {
          this.$router.push({ name: 'MovieShow', params: { id: this.id } });
        }).catch((err) => {
          this.errors = err.response.data.error;
        });
    }
  },
};

</script>

<style lang="scss" scoped>

</style>
